import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/pro-regular-svg-icons/faArrowLeft";

import Button from "@/components/Global/Button/Button";

import styles from "./TitleOnlyHeader.module.scss";

export default function TitleOnlyHeader({handleBack, children, backButtonText}) {
  return (
    <>
      <div className={"row mx-0 g-0 gx-3 px-2 py-4 align-items-center position-relative"}>
        <div className="col-auto">
          <Button variant="transparent" className="p-0" onClick={() => handleBack()} aria-label="Go back">
            <FontAwesomeIcon icon={faArrowLeft} size="lg" className="ps-2" /> {backButtonText}
          </Button>
        </div>
        <div className="col text-center fw-semibold">{children}</div>
        <div className="col-1"></div>
      </div>
    </>
  );
}
